/* Shopify Ajax discounts. Never infer acceptance from a redirect or a successful HTTP status. */
(function (global) {
  'use strict';
  const equal = (a, b) => String(a).toLocaleLowerCase() === String(b).toLocaleLowerCase();
  function codes(cart) {
    if (!Array.isArray(cart?.discount_codes) || cart.discount_codes.some(row => typeof row.code !== 'string' || typeof row.applicable !== 'boolean')) {
      throw new Error('The cart did not return verifiable discount details. Please review your cart or enter the code at checkout.');
    }
    return cart.discount_codes;
  }
  function allocated(cart, code) {
    const applications = [...(cart.cart_level_discount_applications || [])];
    for (const line of cart.items || []) for (const allocation of line.discount_allocations || line.line_level_discount_allocations || []) applications.push(allocation.discount_application);
    return applications.some(a => a?.type === 'discount_code' && equal(a.title, code));
  }
  function create({client, shared = global, withLock = task => task()} = {}) {
    async function update(raw, remove = false, sectionRequest = {}) {
      const code = String(raw || '').trim();
      if (!code || code.length > 255 || /[,\u0000-\u001f\u007f]/.test(code)) throw new Error('Enter one discount code, without commas.');
      if (shared.occCartMutationBusy) throw new Error('Your cart is updating. Please wait and try again.');
      return withLock(async () => {
        if (shared.occCartMutationBusy) throw new Error('Your cart is updating. Please wait and try again.');
        shared.occCartMutationBusy = 'discount';
        let sent = false;
        try {
          const before = await client.readCart();
          const existing = codes(before);
          if (remove && !existing.some(row => equal(row.code, code))) return {state: 'absent', message: 'That code is no longer in the cart.', cart: before, changed: false};
          const requested = existing.map(row => row.code).filter(value => !equal(value, code));
          if (!remove) requested.push(code);
          sent = true;
          const cart = await client.request('cart/update.js', {...sectionRequest, discount: requested.join(',')});
          const current = codes(cart), match = current.find(row => equal(row.code, code));
          if (remove && match) throw new Error('Removal could not be confirmed.');
          const state = remove ? 'removed' : match?.applicable === false ? 'rejected' : match?.applicable === true ? (allocated(cart, code) ? 'applied' : 'checkout') : 'unconfirmed';
          const messages = {
            removed: 'Code removed. Cart prices have been refreshed.',
            rejected: 'This code does not apply to the current cart. Check its spelling and offer conditions, or try another code.',
            applied: 'Code applied. Cart prices have been refreshed.',
            checkout: 'Code accepted, but no item-price reduction is shown here. Any delivery discount and final eligibility are confirmed at checkout.',
            unconfirmed: 'This code was not confirmed by the cart. Check the offer conditions or enter it at checkout.'
          };
          return {state, message: messages[state], cart, changed: true};
        } catch (error) {
          if (sent) throw new Error('We could not confirm the discount update. Review the current cart before trying again.', {cause: error});
          throw error;
        } finally {
          if (shared.occCartMutationBusy === 'discount') shared.occCartMutationBusy = false;
        }
      });
    }
    return {update};
  }
  global.OCCCartDiscountCore = {create, codes, allocated};
})(typeof window !== 'undefined' ? window : globalThis);
